import React, { FC } from "react";
import laptopScrewdriver from "@/assets/studentTile/laptop-screwdriver.svg?url";
import { Image, Text, Flex } from "@chakra-ui/react";
import { useClassroomLayoutStore } from "@/stores/v2/classroomLayoutStore";
import InactiveTileContentLayout from "@/js/components/StudentTile/components/inactiveScreenStates/InactiveTileContentLayout";

const CannotDisplayActivity: FC = () => {
	const tileSize = useClassroomLayoutStore((state) => state.tileSize);

	return (
		<Flex flexDirection={"column"} align={"center"} height={tileSize !== "sm" ? "100%" : ""}>
			{tileSize !== "sm" && <Image src={laptopScrewdriver} htmlHeight={42} htmlWidth={42} />}
			<InactiveTileContentLayout>
				<Text fontWeight={"bold"}>Cannot display activity</Text>
				<Text>Our team has been made aware. We'll keep trying to reconnect during class.</Text>
			</InactiveTileContentLayout>
		</Flex>
	);
};

export default CannotDisplayActivity;
